// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../../contexts/ModuleContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useCollateralUserService: () => UseQueryResult<
  TemplateContract<UserService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  return useQueryWithOffset({
    queryKey: ['queryCollateralUserService', operator, party],
    queryFn: async (_, offset) => {
      if (!operator) {
        throw new Error('Operator party was undefined in useUserService');
      }
      return ledgerApi.queryCollateralUserService(offset, operator, party);
    },
  });
};
